import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';
import { CssSelectors } from '../../../../../web/styles/styles';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	actionButtonsWrap: {
		display: 'flex',
		gap: 8,
		justifyContent: 'flex-end',
		marginTop: 24,
	},
	availabilityCheckButtonWrap: {
		minWidth: 120,
		flex: 1,
		display: 'flex',
		gap: 8,
	},
	availabilityCheckIcon: {
		position: 'absolute',
		top: '50%',
		right: 8,
		transform: 'translateY(-50%)',
	},
	container: {
		padding: '16px 24px',
	},
	description: {
		fontSize: 14,
		color: colors.text.dark,
		marginBottom: 16,
		lineHeight: '1.5',
	},
	domainNameActionButton: {
		transform: 'translateY(10px)',
		color: colors.primary.main,
		...CssSelectors.allChildren(
			{
				display: 'block',
			},
			'span'
		),
	},
	domainNameInputWrap: {
		flex: 1,
		marginRight: 16,
	},
	domainNameInputError: {
		borderColor: colors.danger.main,
	},
	domainNameLabel: {
		display: 'inline-flex',
		position: 'relative',
		fontSize: 14,
		fontWeight: 'bold',
		marginBottom: 8,
		':after': {
			content: '""',
			display: 'block',
			position: 'absolute',
			left: '100%',
			top: 0,
			width: 20,
			height: 20,
			zIndex: 1,
		},
	},
	domainNameWrap: {
		display: 'flex',
		margin: '16px 0',
		alignItems: 'center',
		justifyContent: 'space-between',
	},
	errorRequired: {
		color: colors.danger.main,
	},
	infoIcon: {
		transform: 'translate(5px, 1px)',
	},
	infoMessage: {
		fontSize: 11,
		maxWidth: 200,
		padding: '4px 8px',
		borderRadius: 4,
		backgroundColor: colors.background.main,
		border: `1px solid ${colors.border.main}`,
	},
	inputWrap: {
		position: 'relative',
	},
	input: {
		paddingRight: 23,
		width: 420,
		maxWidth: 500,
	},
	loaderWrap: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		minHeight: 100,
		width: '100%',
	},
	popoverWrap: {
		display: 'flex',
	},
	title: {
		fontSize: 18,
		fontWeight: 'bold',
		marginBottom: 12,
		color: colors.text.dark,
	},
	xIcon: {
		...CssSelectors.allChildren(
			{
				transform: 'translate(0px, 0px)',
			},
			'g'
		),
	},
	modal: {
		':nth-child(1n) > .modal-overlay': {
			':nth-child(1n) > .modal-overlay-content': {
				width: 640,
			},
		},
	},
});
